'use client';

// A tap on the "needs review" or "sign in" notification opens Storage & Sync (BL-2685, AC 6). The
// native side posts the notification with a route key; the gateway delivers the key of a tap, and
// this hook navigates in the shell. Other keys are ignored.

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { offlinePageHref } from '@auctogon/admin-isomorphic/isomorphic/offline/offline-routes';
import { getNativeDeviceGateway } from '../../gateways/native-device';
import { NATIVE_TRANSFER_STORAGE_SYNC_ROUTE } from '../../gateways/native-device/native-transfer/plugin-methods';

/**
 * @param enabled - true inside the native app.
 * @sideEffect Listens for notification taps while mounted, and navigates to Storage & Sync on one.
 */
export function useOpenStorageSyncOnTap(enabled: boolean): void {
  const router = useRouter();
  useEffect(() => {
    if (!enabled) return;
    let live = true;
    let unsubscribe: (() => void) | null = null;
    getNativeDeviceGateway()
      .then((gateway) => {
        if (!live) return;
        unsubscribe = gateway.onNotificationRoute((route) => {
          if (route === NATIVE_TRANSFER_STORAGE_SYNC_ROUTE) router.push(offlinePageHref());
        });
      })
      .catch((err: unknown) => {
        // eslint-disable-next-line no-console -- client module; createLogger is server-only (ALS).
        console.error('notification route: could not listen', err instanceof Error ? err : new Error(String(err)));
      });
    return () => {
      live = false;
      unsubscribe?.();
    };
  }, [enabled, router]);
}
